import { axios } from 'src/api/axios';

export const getApiKeySign = () => axios.get('api_v1/auth/new?never_expires=false');

// export const postMessageSign = ({ key, data }) => {
export const postMessageSign = ({ data }) => {
  // const url = `api_v1/send_message?api-key=${key}`;
  const url = 'api_v1/send_message';
  axios.post(url, data);
};
